
export default {
  BY_TICKET: 'byTicket',
  OCCUPATIONAL: 'occupational',
  SELF_PAYING: 'selfPaying',
  HISTORY: 'history'
};



// WEBPACK FOOTER //
// ./src/enums/pathTypes.js